import { HubsLogbook } from "Models";
import { CustomField } from "Components";
import { TFunction } from 'react-i18next';
import { Form, useMaxLengthValidation, useNumberValidation, useRequireFieldValidation } from "@cae/component-library";



export const NewRequestForm = (t: TFunction<'forms'>, isAdmin?:boolean): Form => {
    const requireFieldValidation = useRequireFieldValidation(t);
    const numberValidation = useNumberValidation(t);

    //Max lengths
    const maxLengthValidation6 = useMaxLengthValidation(t, 6);
    const maxLengthValidation25 = useMaxLengthValidation(t, 25);
    const maxLengthValidation50 = useMaxLengthValidation(t, 50);
    const maxLengthValidation500 = useMaxLengthValidation(t, 500);
    
    return {
        "partNumber": {
            label: t('newRequestForm.partNumber'),
            value: "",
            validations: [requireFieldValidation, maxLengthValidation25],
            fieldType: "custom",
            placeHolder: t('newRequestForm.partNumber'),
            customField: (props: any) => <CustomField  { ...props } />
        },
        "itemCost": {
            label: t('newRequestForm.itemCost'),
            value: "",
            validations: [requireFieldValidation, numberValidation],
            fieldType: "text"
        },
        "contract": {
            label: t('newRequestForm.contract'),
            value: "",
            validations: [requireFieldValidation, maxLengthValidation6],
            fieldType: "select",
            options: []
        },
        "quantity": {
            label: t('newRequestForm.quantity'),
            value: "",
            validations: [requireFieldValidation, numberValidation],
            fieldType: "text",
            placeHolder: t('newRequestForm.quantity')
        },
        "issueType": {
            label: t('newRequestForm.issue'),
            value: "",
            validations: [requireFieldValidation, maxLengthValidation500],
            fieldType: "select",
            options: [
                { key: 'Received Damaged', value: 'Received Damaged' },
                { key: 'Damaged on Site', value: 'Damaged on Site' },
                { key: 'Lost (Part on Packing List)', value: 'Lost (Part on Packing List)' },
                { key: 'Missing (Not on packing list)', value: 'Missing (Not on packing list)' },
                { key: 'Quality Issue', value: 'Quality Issue' },
                { key: 'New Request / Not on BOM', value: 'New Request / Not on BOM' }
            ]
        },
        "category": {
            label: t('newRequestForm.category'),
            value: "ORDER & SHIP PART",
            validations: [requireFieldValidation,maxLengthValidation50],
            fieldType: "select",
            placeHolder: t('newRequestForm.category'),
            options: []
        },
        "criticity": {
            label: t('newRequestForm.priority'),
            value: "Normal",
            validations: [requireFieldValidation],
            fieldType: "select",
            placeHolder: t('newRequestForm.criticalLevel'),
            options: [{key:'AOG', value:'AOG'}, {key:'Urgent', value:'Urgent'}, {key:'Normal', value:'Normal'}]
        },
        "description": {
            label: t('newRequestForm.comments'),
            value: "",
            fullwidth: true,
            validations: [requireFieldValidation],
            fieldType: "text"
        },
        "comments": {
            label: t('newRequestForm.hubsComments'),
            value: "",
            fullwidth: true,
            validations: [],
            fieldType: "text",
            hidden:!isAdmin
        }
}};

export const ConvertNewRequestFormToHubsLogbookModel = (newRequestForm: Form): HubsLogbook => {
    const newHubsLogbook = new HubsLogbook();
    Object.keys(newRequestForm).forEach(formKey => {
        newHubsLogbook[formKey] = newRequestForm[formKey].value;
    })

    return newHubsLogbook;
}